var tldjs = require('tldjs');

const tld = tldjs.fromUserSettings({
  validHosts: ['localhost'],
});


const practiceUtils = (function () {
  const _getSubdomain = function () {
    let subdomain = tld.getSubdomain(document.location.hostname);
    const parts = subdomain.split('.');

    if (parts.length >= 2) {
      // e.g. subdomain.staging.mygi.health
      subdomain = parts[0];
    }

    return subdomain;
  };
  return {
    getSubdomain: _getSubdomain,
  }
})();

module.exports = practiceUtils;



// WEBPACK FOOTER //
// ./src/common/modules/practice/practiceUtils.js